<template>
  <div>
    <div class="formCom" v-if="!alertModal" @click.self="closeModal">
      <div class="form">
        <button class="close" @click="closeModal">
          <CloseIcone></CloseIcone>
        </button>
        <div class="name">Add Dust Kit</div>
        <div class="step-indicator">
          <span
            class="step-dot"
            :class="{ active: currentFormPart === 0 }"
            @click="goToStep(0)"
          >1</span>
          <span class="step-line"></span>
          <span
            class="step-dot"
            :class="{ active: currentFormPart === 1 }"
            @click="goToStep(1)"
          >2</span>
        </div>
        <!-- Step 0: Basic Info -->
        <div class="com" v-show="currentFormPart == 0">
          <div class="input-wrap">
            <input
              type="text"
              class="input toUppercase"
              name="kit_dashboard_v2"
              placeholder="Kit ID"
              data-vv-as="Kit ID"
              v-model="kit_id"
              :class="{ invalid: errors.has('kit_dashboard_v2') }"
              v-mask="'XX - XX - XXX - XXXX'"
              v-validate="{ required: true, length: 20 }"
              @focusout="extractKitPart"
            />
            <span class="validate-error" v-if="errors.has('kit_dashboard_v2')">
              {{ errors.first("kit_dashboard_v2") }}
            </span>
          </div>
          <div class="input-wrap">
            <input
              type="text"
              class="input"
              placeholder="Number Of Samples"
              data-vv-as="Number Of Samples"
              v-model="indoor_samples"
              maxlength="1"
              name="samples_v2"
              v-validate="'required|numeric|max_value:4'"
              @input="indoor_samples = indoor_samples.replace(/\D/g, '')"
            />
            <span class="validate-error" v-if="errors.has('samples_v2')">
              {{ errors.first("samples_v2") }}
            </span>
          </div>
          <div class="input-wrap title_radio sub-filter">
            <span class="radio-span">
              <input
                type="radio"
                name="paymentMethodV2"
                value="1"
                data-vv-as="Payment Method"
                v-model="paymentMethod"
                v-validate="'required'"
              />Paid
            </span>
            <span class="radio-span">
              <input
                type="radio"
                name="paymentMethodV2"
                value="0"
                data-vv-as="Payment Method"
                v-model="paymentMethod"
                v-validate="'required'"
              />Promo
            </span>
            <span class="validate-error" v-if="errors.has('paymentMethodV2')">
              {{ errors.first("paymentMethodV2") }}
            </span>
          </div>
        </div>

        <!-- Step 1: Additional Info -->
        <div class="com" v-show="currentFormPart == 1">
          <div class="inputs-wrap small">
            <div class="input-wrap">
              <div class="datepickerWrapDiv">
                <Datepicker
                  placeholder="Expiration Date"
                  class="custom-datepicker"
                  v-model="expiration_date"
                  :format="formatDate"
                  minimum-view="month"
                  :disabled-dates="{ to: new Date() }"
                  :calendar-class="{ calendarWrap: true }"
                  :class="{ datepickerWrapAdmin: true }"
                  :input-class="{ datepickerInputAdmins: true }"
                ></Datepicker>
                <img
                  src="../../images/dashboard/calendar.png"
                  alt="Calendar"
                  class="datepickerWrapDiv-img"
                />
                <button
                  class="datepickerWrapDiv-img-cross"
                  v-if="expiration_date !== null"
                  @click="expiration_date = null"
                >
                </button>
              </div>
            </div>
          </div>
          <div class="input-wrap">
            <input
              type="number"
              class="input no-arrows"
              maxlength="5"
              placeholder="Order Number"
              v-model="OrderNumber"
              oninput="this.value = this.value.slice(0, 5)"
            />
          </div>
          <div class="input-wrap">
            <input
              type="text"
              class="input toLowerCase"
              placeholder="Email"
              data-vv-as="Email"
              name="collected_email_v2"
              v-validate="'email'"
              :class="{ invalid: errors.has('collected_email_v2') }"
              v-model="collectedEmail"
            />
            <span class="validate-error" v-if="errors.has('collected_email_v2')">
              {{ errors.first("collected_email_v2") }}
            </span>
          </div>
          <div class="input-wrap">
            <input
              type="text"
              class="input toUppercase"
              placeholder="Shipping Method"
              v-model="shipMethod"
            />
          </div>
          <div class="input-wrap">
            <input
              type="number"
              class="input no-arrows"
              placeholder="Tracking Number"
              v-model="trackNumber"
            />
          </div>
          <div class="input-wrap">
            <input
              type="number"
              class="input no-arrows"
              placeholder="Pump SN"
              v-model="pumpSn"
            />
          </div>
        </div>

        <!-- Navigation Buttons -->
        <div v-show="currentFormPart == 0">
          <button
            class="btn"
            @click.prevent="next"
          >
            Continue
          </button>
        </div>
        <div v-show="currentFormPart == 1">
          <div class="d-flex">
            <button class="btn-back" @click="back">
              Back
            </button>
            <button
              class="btn"
              @click.prevent="$validator.validateAll()"
              @click="addKit"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <CommonAlertModal
        v-if="alertModal"
        @closeAlertModal="closeModal"
        :message="'Dust Kit Added.'"
      ></CommonAlertModal>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import { mask } from "vue-the-mask";
import CloseIcone from "../../images/shared/cancel";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import CommonAlertModal from "../../components/CommonAlertModal";

export default {
  name: "AddTestKitV2",
  directives: { mask },
  data() {
    return {
      kit_id: null,
      indoor_samples: null,
      paymentMethod: null,
      OrderNumber: null,
      shipMethod: null,
      trackNumber: null,
      collectedEmail: null,
      pumpSn: null,
      expiration_date: null,
      currentFormPart: 0,
      alertModal: false
    };
  },
  components: {
    CloseIcone,
    Datepicker,
    CommonAlertModal
  },
  computed: {
    isComplete() {
      return this.kit_id && this.indoor_samples && this.paymentMethod;
    },
    ...mapGetters(["serverValidation"])
  },
  watch: {
    serverValidation(error) {
      if (error && error.length) {
        error.forEach(item => {
          if (!this.$validator.errors.has(item.field)) {
            this.$validator.errors.add({ field: item.field, msg: item.message });
          }
        });
      }
    },
    kit_id() {
      this.errors.clear();
      this.clearServerValidationErrors();
    }
  },
  methods: {
    ...mapActions(["addTestKitV2", "sendSearchReqV2", "kitexistV2"]),
    ...mapMutations(["clearServerValidationErrors"]),
    parseKitId(kitId) {
      if (!kitId) return null;
      return kitId
        .replace(/[-\s]/g, "")
        .substring(0, 11)
        .toUpperCase();
    },
    extractKitPart() {
      if (this.errors.has("kit_dashboard_v2")) {
        this.indoor_samples = "";
        return;
      }
      const kitId = this.parseKitId(this.kit_id);
      const kitValue = this.extractKitValue(kitId);
      if (kitValue) {
        this.indoor_samples = kitValue.charAt(1);
      }
    },
    extractKitValue(kitId) {
      if (!kitId) return null;
      const match = kitId.match(/(F[1-3]|R[1-3])/i);
      if (match) {
        return match[0];
      }
      return null;
    },
    async next() {
      this.errors.clear();
      this.clearServerValidationErrors();
      const isValid = await this.$validator.validateAll();
      if (!isValid || !this.isComplete) {
        return;
      }
      const data = {
        kit_id: this.parseKitId(this.kit_id)
      };
      try {
        await this.kitexistV2(data);
        this.currentFormPart = 1;
      } catch (e) {
        // server validation error is set via the serverValidation watcher
      }
    },
    back() {
      this.currentFormPart = 0;
    },
    goToStep(step) {
      if (step === 1 && (!this.isComplete || this.errors.any())) {
        return;
      }
      this.currentFormPart = step;
    },
    addKit() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      const data = {
        kit_id: this.parseKitId(this.kit_id),
        indoor_samples: this.indoor_samples,
        price_type: this.paymentMethod,
        order_number: this.OrderNumber,
        collected_email: this.collectedEmail,
        ship_method: this.shipMethod,
        track_number: this.trackNumber,
        pump_sn: this.pumpSn,
        expiration_at:
          this.expiration_date != null
            ? moment(this.expiration_date).format()
            : null
      };
      this.addTestKitV2(data)
        .then(res => {
          this.errors.clear();
          this.clearServerValidationErrors();
          this.sendSearchReqV2();
          this.alertModal = true;
        })
        .catch(() => {
          this.currentFormPart = 0;
        });
    },
    closeModal() {
      this.errors.clear();
      this.clearServerValidationErrors();
      this.$emit("closeModal", false);
    },
    formatDate(date) {
      return moment(date).format("MMM/YYYY");
    }
  }
};
</script>

<style scoped>
.d-flex {
  display: flex;
}

.d-flex button {
  margin-right: 10px;
}

.close {
  position: absolute;
  right: 15px;
  top: 15px;
  border: 1px solid transparent;
  cursor: pointer;
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: transparent;
}

.formCom {
  background-color: rgba(219, 230, 241, 0.5);
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
  z-index: 99;
}

.input.invalid {
  border: 1px solid red;
}

.form {
  padding: 25px;
  background-color: #fff;
  max-width: 397px;
  width: 100%;
  position: relative;
  z-index: 1;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.name {
  color: #005eb8;
  font-size: 24px;
  margin: 0 0 10px 0;
  text-align: center;
  font-family: TTNormsMedium, sans-serif;
}

.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.step-dot {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: #e4e4e4;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
  cursor: pointer;
  transition: all 0.3s ease;
}

.step-dot.active {
  background-color: #005eb8;
  color: #fff;
}

.step-line {
  width: 40px;
  height: 2px;
  background-color: #e4e4e4;
  margin: 0 8px;
}

.input-wrap {
  width: 100%;
  margin: 0 0 30px 0;
}

.input {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  padding: 15px 20px !important;
  color: #4d4d4d !important;
  width: 100% !important;
  font-size: 14px !important;
  font-family: TTNormsLight, sans-serif !important;
  text-align: center !important;
  outline: none !important;
}

.input::placeholder {
  color: #98a4ae;
  font-size: 14px;
  text-transform: capitalize;
  font-family: TTNormsLight, sans-serif;
}

.validate-error {
  bottom: -23px;
  height: 20px;
  color: red;
  font-size: 12px;
  font-family: TTNormsLight, sans-serif;
}

.toUppercase {
  text-transform: uppercase;
}

.toLowerCase {
  text-transform: lowercase;
}

.btn {
  background-color: #6cc24a;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}

.btn:hover:enabled {
  background-color: transparent;
  color: #6cc24a;
  border: 1px solid #6cc24a;
}

.btn:disabled {
  cursor: default;
  background-color: rgba(108, 194, 74, 0.2);
  color: #6cc24a;
}

.btn-back {
  background-color: #005eb8;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsMedium, sans-serif;
}

.btn-back:hover:enabled {
  background-color: transparent;
  color: #005eb8;
  border: 1px solid #005eb8;
}

.btn-back:disabled {
  cursor: default;
  background-color: rgba(0, 94, 184, 0.2);
  color: #005eb8;
}

.title_radio {
  color: #005eb8;
  font-size: 15px;
  font-family: TTNormsMedium, sans-serif;
  width: 100%;
  justify-content: space-between;
  cursor: pointer;
  text-align: center;
}

.radio-span {
  margin: 0 10px;
}

.com {
  margin: 36px 0 0 0;
}

.no-arrows {
  -moz-appearance: textfield;
  appearance: textfield;
}

.no-arrows::-webkit-inner-spin-button,
.no-arrows::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Datepicker */
.datepickerWrapDiv {
  position: relative;
}

.datepickerWrapAdmin {
  border: 1px solid #e4e4e4;
  border-radius: 2px;
  color: #4d4d4d !important;
  width: 100% !important;
  font-size: 14px !important;
  font-family: TTNormsLight, sans-serif !important;
  text-align: center !important;
  outline: none !important;
}

.custom-datepicker {
  max-width: none !important;
  margin: 0px;
}

.datepickerWrapDiv-img {
  position: absolute;
  left: 18px;
  top: 8px;
  max-width: 18px;
}

.datepickerWrapDiv-img-cross {
  padding: 0;
  cursor: pointer;
  background-color: transparent;
  border: none;
  width: 11px;
  display: flex;
  align-self: center;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  height: 11px;
}
</style>
